// Save as: src/TemplateBuilder/TableConfigModal.js
//
// Lets the user build the join path for a table (e.g. Order -> OrderItems ->
// OrderSpecifications -> OrderGSM), pick which columns from any entity in that
// path to display, and declare how the table binds to the document's root
// record - e.g. "filter Pi.CommercialId = the CommercialId this document is
// generated for", matching how your existing get_commercial_pdf_table_info
// endpoint filters via a Pi subquery.

import React, { useState } from 'react';

const TableConfigModal = ({ catalog, tableElement, onSave, onClose }) => {
  const [path, setPath] = useState(tableElement.path || []);
  const [columns, setColumns] = useState(tableElement.columns || []);
  const [rootEntity, setRootEntity] = useState(tableElement.filters?.[0]?.field?.split('.')[0] || '');
  const [rootField, setRootField] = useState(tableElement.filters?.[0]?.field?.split('.')[1] || '');
  const [rootName, setRootName] = useState(
    tableElement.filters?.[0]?.value?.toString().replace('$ROOT.', '') || 'Commercial'
  );

  const addPathStep = (entity) => entity && setPath((prev) => [...prev, entity]);
  const removeLastStep = () => setPath((prev) => prev.slice(0, -1));

  const currentEntity = path[path.length - 1];
  const availableNext = currentEntity ? Object.keys(catalog[currentEntity]?.relations || {}) : Object.keys(catalog);

  const toggleColumn = (fieldPath) => {
    setColumns((prev) =>
      prev.some((c) => c.field === fieldPath)
        ? prev.filter((c) => c.field !== fieldPath)
        : [...prev, { field: fieldPath, label: fieldPath.split('.')[1] }]
    );
  };

  const handleSave = () => {
    onSave({
      path,
      columns,
      filters: rootEntity && rootField ? [{ field: `${rootEntity}.${rootField}`, op: '=', value: `$ROOT.${rootName}` }] : []
    });
  };

  return (
    <div
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
      }}
    >
      <div style={{ background: 'white', width: 480, maxHeight: '80vh', overflowY: 'auto', padding: 20, borderRadius: 8 }}>
        <h3>Configure table</h3>

        <div style={{ marginBottom: 12 }}>
          <div style={{ fontWeight: 'bold', marginBottom: 4 }}>Data path</div>
          <div style={{ marginBottom: 4 }}>{path.join(' \u2192 ') || '(none yet)'}</div>
          <select onChange={(e) => addPathStep(e.target.value)} value="">
            <option value="">+ add {path.length ? 'related' : 'root'} entity...</option>
            {availableNext.map((e) => (
              <option key={e} value={e}>{e}</option>
            ))}
          </select>
          {path.length > 0 && <button onClick={removeLastStep} style={{ marginLeft: 6 }}>Remove last</button>}
        </div>

        <div style={{ marginBottom: 12 }}>
          <div style={{ fontWeight: 'bold', marginBottom: 4 }}>Columns</div>
          {path.map((entity) => (
            <div key={entity} style={{ marginBottom: 6 }}>
              <div style={{ fontSize: 12, color: '#777' }}>{entity}</div>
              {(catalog[entity]?.fields || []).map((field) => (
                <label key={field} style={{ display: 'block', fontSize: 13 }}>
                  <input
                    type="checkbox"
                    checked={columns.some((c) => c.field === `${entity}.${field}`)}
                    onChange={() => toggleColumn(`${entity}.${field}`)}
                  />{' '}
                  {field}
                </label>
              ))}
            </div>
          ))}
        </div>

        <div style={{ marginBottom: 12 }}>
          <div style={{ fontWeight: 'bold', marginBottom: 4 }}>Bind to document root</div>
          <select value={rootEntity} onChange={(e) => setRootEntity(e.target.value)}>
            <option value="">(select entity in path to filter)</option>
            {path.map((e) => (
              <option key={e} value={e}>{e}</option>
            ))}
          </select>{' '}
          <input placeholder="field, e.g. CommercialId" value={rootField} onChange={(e) => setRootField(e.target.value)} />{' '}
          <input placeholder="root name, e.g. Commercial" value={rootName} onChange={(e) => setRootName(e.target.value)} />
        </div>

        <button onClick={handleSave}>Save</button>{' '}
        <button onClick={onClose}>Cancel</button>
      </div>
    </div>
  );
};

export default TableConfigModal;
